/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Faq_1_QInputs */

const en_cp_faq_1_q = /** @type {(inputs: Cp_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does this mean students stop learning to code because AI does the work?`)
};

const id_cp_faq_1_q = /** @type {(inputs: Cp_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah ini berarti mahasiswa tidak belajar coding karena AI yang mengerjakan?`)
};

/**
* | output |
* | --- |
* | "Does this mean students stop learning to code because AI does the work?" |
*
* @param {Cp_Faq_1_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_faq_1_q = /** @type {((inputs?: Cp_Faq_1_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Faq_1_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_faq_1_q(inputs)
	return en_cp_faq_1_q(inputs)
});